<template>
  <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :title="'Sửa khoản thu : '+ nameKT "
      :visible.sync="isOpenDetailKT"
      top="5vh"
      width="500px"
  >
    <el-form ref="formReq" :label-position="labelPosition" :model="formReq" :rules="rules">
      <el-form-item :label-width="'80px'" label="Số lượng" prop="quantityKT">
        <el-input-number v-model="formReq.quantityKT"></el-input-number>
        <span v-if="formReq.quantityKT<0" class="error-message"> &nbsp; &nbsp;* Nhà trường hoàn tiền.</span>
      </el-form-item>
      <el-form-item :label-width="'80px'" label="Đơn giá" prop="priceKT">
        <el-currency-input id="priceKT" v-model="formReq.priceKT" autocomplete="off"
                           style="text-align: center"
        ></el-currency-input>
      </el-form-item>
      <el-form-item :label-width="'80px'" label="Giảm giá" prop="discountKT">
        <el-currency-input id="discountKT" v-model="formReq.discountKT" autocomplete="off"
                           style="text-align: center" type="number"
        ></el-currency-input>
      </el-form-item>
    </el-form>
    <div style="font-size: 20px; margin-left: 1px;" v-if="Number(formReq.quantityKT) === 0">Thành tiền :
      {{ 0 | formatCurrency }}
    </div>
    <div style="font-size: 20px; margin-left: 1px;" v-if="Number(formReq.quantityKT) > 0">Thành tiền :
      {{ (Number(formReq.quantityKT) * Number(formReq.priceKT)) - formReq.discountKT | formatCurrency }}
    </div>
    <div style="font-size: 20px; margin-left: 1px;" v-if="Number(formReq.quantityKT) < 0">Thành tiền :
      {{ (Number(formReq.quantityKT) * Number(formReq.priceKT)) + formReq.discountKT | formatCurrency }}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveDetailKT('formReq')" :loading="loadingButton">Cập nhật </el-button>
    <el-button type="danger" @click="handleClose">  <i class="el-icon-circle-close"/> Đóng</el-button>
      </span>
  </el-dialog>
</template>

<script>

import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "DetailKTRevenueDialog",

  data() {
    const checkPrice = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('Không được để trống!'));
      }
      if (this.formReq.quantityKT > 0 && Number(value) > Number(this.formReq.priceKT) * Number(this.formReq.quantityKT) && Number(this.formReq.priceKT) * Number(this.formReq.quantityKT) > 0) {
        callback(new Error('Giảm giá không lớn hơn tiền khoản thu'));
      } else {
        callback();
      }
    }
    return {
      loadingButton: false,
      rules: {
        discountKT: [{
          validator: checkPrice,
          trigger: 'change',
          required: true,
        }],
        priceKT: [{
          required: true,
          message: "Không được để trống!",
          trigger: "change",
        }],
        quantityKT: [{
          required: true,
          message: "Không được để trống!",
          trigger: "change",
        }],
      },
      nameKT: "",
      indexKt: null,
      idManagerTuition: null,
      formReq: {
        priceKT: 0,
        quantityKT: 0,
        discountKT: 0,
      },
      dataResp: {
        moneyKt: 0,
        priceKt: 0,
        quantityKt: 0,
        discountKt: 0,
        id: 0,
        nameKt: "",
      },
      dataReq: {
        orderKidCode: "",
        collectionTurn: 0,
        nameKt: "",
        moneyKt: 0,
        quantityKt: 0,
        priceKt: 0,
        discountKt: 0,
      },
      labelPosition: 'left',
      statusOrder: "",
    }
  },

  props: {
    isOpenDetailKT: {
      type: Boolean,
      default: () => false,
    },
    idOrder: {
      type: Number,
      default: () => 0
    }
  },
  methods: {
    async showDetailKT(orderKidCode, collectionTurn, nameKt, type, year) {
      this.dataReq.orderKidCode = orderKidCode
      this.dataReq.collectionTurn = collectionTurn
      this.dataReq.nameKt = nameKt
      this.dataReq.id = this.$props.idOrder
      await revenueManagementService.showDetailPayment(this.dataReq.orderKidCode, this.dataReq.collectionTurn, this.dataReq.nameKt, type, year).then((resp) => {
        this.formReq.quantityKT = resp.data.data.quantityKt
        this.formReq.priceKT = resp.data.data.priceKt
        this.formReq.discountKT = resp.data.data.discountKt
        this.nameKT = resp.data.data.nameKt
      })
    },

    saveDetailKT(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingButton = true
          this.dataResp.quantityKt = this.formReq.quantityKT;
          this.dataResp.priceKt = this.formReq.priceKT;
          this.dataResp.discountKt = this.formReq.discountKT;
          if(Number(this.formReq.quantityKT) >= 0){
            this.dataResp.moneyKt = (this.formReq.quantityKT * this.formReq.priceKT) - this.formReq.discountKT;
          } else {
            this.dataResp.moneyKt = (this.formReq.quantityKT * this.formReq.priceKT) + this.formReq.discountKT;
          }
          this.dataResp.id = this.$props.idOrder
          this.dataResp.nameKt = this.dataReq.nameKt
          revenueManagementService.updateDetailPayment(this.dataResp).then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Cập nhật thành công")
            this.loadingButton = false;
            this.handleClose()
          }).catch((err) => {
            console.log(err);
            NotifyMessage.leftCornerNotificationError(err.message)
          });
        } else {
          this.loadingButton = false
        }
      });


    },
    handleClose() {
      this.loadingButton = false
      this.$refs.formReq.resetFields();
      this.$emit("close");
    },
  },


}
</script>

<style scoped>

.el-form-item .error-message {
  color: red;
}

</style>